export const getDeviceMemoryInfo = () => {
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deviceMemory: `${(navigator as any).deviceMemory} GB`,
    hardwareConcurrency: navigator.hardwareConcurrency
  };
};
